import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@a-type/ui';
import { AnimatePresence, motion } from 'motion/react';
import { Children, useId, useState } from 'react';
import { gesture } from '../dnd/gestureStore.js';
import { TokenSpace } from './TokenSpace.js';
/**
 * Renders a list of Tokens which can be reordered by dragging.
 * It automatically inserts gaps between tokens to allow for dropping between
 * items. If your list doesn't take up the entire vertical space, consider
 * adding another TokenSpace below it to append new items.
 *
 * For Tokens rendered in SortableTokenList, the `movedBehavior` prop
 * should be set to 'fade' which produces the most stable animations on
 * drop. This gives the user context on where they are reordering the
 * item from, as well.
 */
export function SortableTokenList({ children: rawChildren, onMove, debug, priority: droppablePriority, disabled, ...rest }) {
    const listId = useId();
    const children = Children.toArray(rawChildren);
    const childrenWithInserts = children.flatMap((child, index) => [
        _jsx(SortableTokenListGap, { index: index, listId: listId, onDrop: (data) => onMove(data, Math.max(0, index)), debug: debug, priority: droppablePriority, disabled: disabled }, `${listId}-gap-${index}`),
        child,
    ]);
    childrenWithInserts.push(_jsx(SortableTokenListGap, { index: children.length, listId: listId, onDrop: (data) => onMove(data, children.length), last: true, debug: debug, priority: droppablePriority, disabled: disabled }, `${listId}-gap-end`));
    return (_jsx(Box, { wrap: true, items: "start", justify: "start", ...rest, children: _jsx(AnimatePresence, { children: childrenWithInserts }) }));
}
const gapSize = 80;
function SortableTokenListGap({ index, listId, last, debug, ...rest }) {
    const [width, setWidth] = useState(0);
    return (_jsx(motion.div, { style: {
            position: 'relative',
            width: 0,
            alignSelf: 'stretch',
            pointerEvents: 'none',
            flex: last ? 1 : undefined,
        }, animate: last ? undefined : { width }, transition: width === 0 ? { duration: 0 } : { duration: 0.08, ease: 'easeInOut' }, children: _jsx(TokenSpace, { id: `${listId}-gap-[${index}]`, onOverAccepted: (token) => {
                if (token)
                    setWidth(gesture.initialBounds.width || gapSize);
                else
                    setWidth(0);
            }, style: {
                minWidth: last ? 40 : gapSize,
                position: 'absolute',
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)',
                height: '120%',
                width: last ? '100%' : '200%',
                outline: debug ? '1px solid red' : undefined,
            }, ...rest }) }));
}
//# sourceMappingURL=SortableTokenList.js.map